





























































































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import ShopHeader from './header/shop-header.vue';
import ShopCondition from './condition/index.vue';
import {
  MaterialType,
  CampaignFormData,
  AdgroupFormData,
  AffiliateVideoSearchType,
  IdentityInfo,
} from '@tt4b/ttam-enums';
import { useCreativeActionTypeIs } from '@tt4b/ttam-hooks';
import TtamMaterialLibrary from './index';
import TtamLibraryList from './list';
import TtamLibraryOperation from './operation/index.vue';
import { useSearch } from './hooks/use-search';

// affiliate费率
const AFFILIATE_FEE_RATE = 3;

const name = 'ttam-material-library-for-shop-compose';

export default defineComponent({
  name,

  components: {
    ShopHeader,
    TtamLibraryList,
    TtamLibraryListTips: TtamMaterialLibrary.TtamLibraryTips,
    TtamLibraryOperation,
    ShopCondition,
  },

  model: { prop: 'selectedIds', event: 'change' },

  // todo spf 简化入参
  props: {
    isLoading: { type: Boolean, default: false },
    list: { type: Array, default: () => [] },
    type: { type: String as PropType<MaterialType>, default: MaterialType.Native },
    param: {
      type: Object as PropType<{
        keyword: '';
        keywordType?: AffiliateVideoSearchType;
        sortType: number | boolean;
        filterTypes: number[];
        page: number;
        totalPage: number;
      }>,
      default: () => ({}),
    },
    limit: { type: Number, default: 20 },
    selectedIds: { type: Array as PropType<number[]>, default: () => [] },

    createMode: { type: String, default: () => '' },
    campaignData: { type: Object as PropType<CampaignFormData>, default: () => ({}) },
    adgroupData: { type: Object as PropType<AdgroupFormData>, default: () => ({}) },
    isSupportAffiliate: {
      type: Boolean,
      default: false,
    },
    isSupportVideoLibrary: {
      type: Boolean,
      default: false,
    },
    curIdentityInfo: {
      type: Object as PropType<IdentityInfo>,
      default: () => ({}),
    },
    isRelatedProduct: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, ctx) {
    const { type, isLoading, param, createMode, adgroupData } = toRefs(props);

    const isNativeType = computed(() => type.value === MaterialType.Native);
    const isPlayableType = computed(() => type.value === MaterialType.Playable);

    /**  暂时写死，后续需要支持ACO后再增加normalCreativeData传参用于计算 */
    const isAco = computed(() => false);
    const isAcoWithTtaNativeAds = computed(() => false);
    const isNative = computed(() => true);
    const isNativePullPost = computed(() => isNative.value && isNativeType.value);
    const { isEdit } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    const isAffiliate = computed(() => type.value === MaterialType.Affiliate);
    const isVideoLibrary = computed(() => type.value === MaterialType.Video);
    const {
      keyword,
      keywordType,
      sortType,
      sortOptions,
      filterTypes,
      filterOptions,
      onParamChange,
      onVideoSourceChange,
    } = useSearch(param, isNativeType, ctx);

    const { title } = TtamMaterialLibrary.usePropsLibraryTitle({ type });

    function onChange(selectedCopy) {
      ctx.emit('change', selectedCopy);
    }

    function onAppend() {
      if (!props.list?.length || isLoading.value) {
        return;
      }
      ctx.emit('append');
    }

    function onSearch() {
      ctx.emit('search');
    }
    const identityChangeHandler = identity => {
      ctx.emit('identity-change', identity);
    };
    const openAuthorizePostDrawer = () => {
      ctx.emit('open-authorize-post-drawer');
    };
    const onIsRelatedProductChange = val => {
      ctx.emit('is-related-product-change', val);
    };
    // 只有原生拉视频支持过滤类型和identity
    const isShowAuthorizeOperation = computed(() => type.value === MaterialType.Native);

    return {
      isAco,
      isNativeType,
      isNativePullPost,
      isPlayableType,
      isAcoWithTtaNativeAds,
      isEdit,
      isAffiliate,
      isVideoLibrary,

      title,
      keyword,
      keywordType,
      sortType,
      sortOptions,
      filterTypes,
      filterOptions,
      isShowAuthorizeOperation,
      AFFILIATE_FEE_RATE,

      onAppend,
      onSearch,
      onChange,
      onParamChange,
      onVideoSourceChange,
      identityChangeHandler,
      openAuthorizePostDrawer,
      onIsRelatedProductChange,
    };
  },
});
